import { PrintColor, PrintType } from '@/types';
import { assertDefined } from '@/utils/assertDefined';
import { compareColors } from '@/utils/colors/compareColors';
import { getPrintColorByFill } from './getPrintColor';

/**
 * First step is trying to find an exact match by matching the fill rgb hex strings (should be uppercase!).
 * If that does not return anything we reduce over the print colors and calculate the color distance of each print color.
 * The print color with the smallest distance wins.
 */
export const getClosestPrintColor = (printType: PrintType, color: string) => {
  const exact = getPrintColorByFill(printType, color);
  if (exact) {
    return exact;
  }

  let minDistance: number = Number.POSITIVE_INFINITY;
  let closestPrintColor: PrintColor | undefined;
  printType.colors.forEach((printColor) => {
    const distance = compareColors(color, printColor.fill);
    if (distance < minDistance) {
      minDistance = distance;
      closestPrintColor = printColor;
    }
  });

  return assertDefined(closestPrintColor);
};
